(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer-stylebike"] && !Shopify.designMode) return;
  try {
    // name="note"
const note = document.getElementById('cart-note-drawer');
// name='attributes[配達希望日]'
const note1 = document.getElementById('cart-attributes-date-drawer');
// name='attributes[希望時間帯]'
const note2 = document.getElementById('cart-attributes-time-drawer');
// name="attributes[備考]"
const note3 = document.getElementById('cart-attributes-note-drawer');

const mergeNote = () => {
  note3.value = note3?.value?.replace(/(配達希望日|希望時間帯)：.+?(\n|$)/gim, "") || "";
  note.value = `${note1.value ? "配達希望日：" + note1.value + '\n' : ""}${
    note2.value ? "希望時間帯：" + note2.value + "\n" : ""
    }${note3.value}`;
}

const cartUpdate = async (keyValues) => {
  const formData = new FormData();
  for (const [key, value] of keyValues) {
		formData.append(`attributes[${key}]`, value);
  }
	const root = window?.Shopify?.routes?.root || "/";
  const _res = await fetch(root + 'cart/update.js', {
	  method: 'POST',
	  body: formData
	});
	// const json = await _res.json();
  // console.log(json);
  return;
}

for (const el of [note1, note2, note3]) {
  el.addEventListener("change", async () => {
    mergeNote();
	 	const keyValues = [
			["配達希望日", note1.value],
			["希望時間帯", note2.value],
			["備考", note3.value],
		]
		await cartUpdate(keyValues)
  });
};

// name='attributes[領収書宛名]'
const receipt_for = document.getElementById('cart-receipt-for-drawer');
// name='attributes[領収書品名]'
const receipt_note = document.getElementById('cart-receipt-note-drawer');

for (const el of [note1, note2, note3]) {
  el.addEventListener("change", async () => {
	 	const keyValues = [
			["領収書宛名", receipt_for.value],
			["領収書品名", receipt_note.value]
		]
		await cartUpdate(keyValues)
  });
};

const addKiboubi = () => setTimeout(async () => {
  const options = Array.from(note1.querySelectorAll("option"));
  if (options.length < 2) {
    const cartJs = (window.Shopify.routes.root || "/") + 'cart.js'
    const cart_res = await fetch(window.Shopify.routes.root + 'cart.js')
    const cart_json = await cart_res.json();
    console.log({cart_json});
    const { attributes } = cart_json;
    note.value = cart_json.note;
    note3.value = attributes["備考"] || "";
    mergeNote()
    const date_res = await fetch("https://calendar.stylebike.co.jp/api/schedule?at_date=2025-08-18");
    const date_json = await date_res.json();
    for (const day of date_json.slice(1)) {
      const opt = document.createElement("option");
      opt.value = day;
      opt.textContent = day;
			if (day === cart_json.attributes['配達希望日']) {
        opt.selected = true
      }
      if (note1) {
        note1.appendChild(opt);
      }
    }
		mergeNote();
  }
}, 1000)

document.addEventListener('theme-drawer:open', (event) => {
  if (event.target.id === 'cart-drawer') {
    // カートドロワーが開いた
    // console.log("drawer open")
    addKiboubi();  
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.getElementById('cart-drawer');
  if (drawer?.hasAttribute('open')) {
    // 初期表示時点ですでに開いている
    // console.log("drawer open")
    addKiboubi();  
  }
});

document.addEventListener('shopify:cart:lines-update', (event) => {
  if (event.detail) {
    // console.log(event.detail.action); // 'add' | 'update' | 'remove'
    // console.log(event.detail.lines);  // 変更された明細
    // 変更が確定（AJAX完了）してから最新の点数を取得
    event.detail.promise?.then(({ cart }) => {
      if (cart) {
        // console.log('新しい商品点数:', cart.totalQuantity);
        addKiboubi();  
      }
    });
    return;
  }
  // 変更確定（AJAX完了）後に最新の商品点数を取得
  event.promise?.then(({ cart }) => {
    if (cart) {
      // console.log('新しい商品点数:', cart.totalQuantity);
      addKiboubi();  
    }
  });
});
  } catch(e) { console.error(e); }
})();

})();
